module.exports = __webpack_public_path__ + "d4c0b303/img/search-filter-icon.c4751a52.svg";